import { UIHeading5, IconHotLeads16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './PromotionDiscountBanner.css';
import { usePromoDiscountBanner } from './hooks/usePromoDiscountBanner';
import { PromoExpiration } from './components/PromoExpiration';

export const PromotionDiscountBanner: React.FC = () => {
  const { endDate, title, resetBanner } = usePromoDiscountBanner();

  if (!endDate) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <div className={styles['icon']}>
        <IconHotLeads16 color="warning_100" />
      </div>
      <div className={styles['container']}>
        <UIHeading5>{title}</UIHeading5>

        <div className={styles['timer']}>
          <PromoExpiration expirationDate={endDate} onDateExpired={resetBanner} />
        </div>
      </div>
    </div>
  );
};
